module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "gPageBorder"
  }, [_c('p', {
    staticClass: "gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('terminal.terRisk.fkpz')))]), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "controlName",
      "label": _vm.$t('lin_global.risk_name'),
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "messageName",
      "label": _vm.$t('lin_global.risk_type'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "radius",
      "label": _vm.$t('lin_global.risk_radius'),
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.cityFormat,
      "label": _vm.$t('lin_global.risk_city'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "controlDesc",
      "label": _vm.$t('lin_global.risk_desc'),
      "width": ""
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gTopMg gPageBorder"
  }, [_c('p', {
    staticClass: "gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('lin_global.risk_warn_info')))]), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.tableData2,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "terminalName",
      "label": _vm.$t('lin_global.label_name')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminalNo",
      "label": _vm.$t('lin_global.label_no'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "eventType",
      "formatter": _vm.formatStatus,
      "label": _vm.$t('lin_global.warn_event'),
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "timeNow",
      "label": _vm.$t('lin_global.time'),
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cityNow",
      "label": _vm.$t('lin_global.city'),
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "longitudeAndlatitude",
      "label": _vm.$t('lin_global.jwd'),
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outDistance",
      "label": _vm.$t('lin_global.distance'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "formatter": _vm.formatStatus1,
      "label": _vm.$t('lin_global.status'),
      "width": "100"
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a5e8cbc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/terminal/terRisk.vue
// module id = 1084
// module chunks = 0